import React, { useState } from "react";
import { Row, Col, Container, Button, Alert } from "reactstrap";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import withRouter from "../../components/Common/withRouter";
import { useTranslation } from "react-i18next";
import {
  forgotPassword,
  loginAction,
  resetPassword,
} from "src/store/auth/saga";
import { useAppSelector } from "src/store";
import avatar1 from "../../assets/images/logo-sm.svg";
import { Formik } from "formik";
import * as Yup from "yup";
import "./style.scss";
import GetInput from "src/components/Form/GetInput";
import { setUser } from "src/store/auth/authSlice";
import { getLanguages } from "src/store/languages/saga";
import { useNavigate } from "react-router";
import Loader from "src/components/Loader";
import { toast } from "react-toastify";
import Layout from "./Layout";

const ResetPassword = (props: any) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const loader = useAppSelector((s) => s.loading.loading);
  const [error, setError] = useState<string>();
  const [msg, setmsg] = useState<string>();
  const navigate = useNavigate();
  const a = localStorage.getItem("language");
  return (
    <React.Fragment>
      <Layout
        title={t("ResetPassword.Title").toString()}
        subtitle={t(
          "ResetPassword.Sub",
          "Yeni şifreni belirle"
        ).toString()}
      >
        {loader && <Loader />}
              <Formik
                initialValues={{
                  Password: "",
                  ConfirmPassword: "",
                }}
                onSubmit={(values) => {
                  const params = location.search
                    .replace("?", "")
                    .replace("userId=", "")
                    .replace("token=", "")
                    .split("&");
                  dispatch(
                    resetPassword({
                      payload: {
                        onSuccess: (message, payload) => {
                          setmsg(message);
                          setTimeout(() => {
                            navigate("/login");
                          }, 2000);
                        },
                        onError: (message) => {
                          setError(message);
                        },
                      },
                      body: {
                        Password: values.Password,
                        Token: params[1],
                        UserId: params[0],
                      },
                    })
                  );
                }}
                validationSchema={Yup.object().shape({
                  Password: Yup.string().required(
                    t("Validation.Required").toString()
                  ),
                  ConfirmPassword: Yup.string()
                    .required(t("Validation.Required").toString())
                    .oneOf(
                      [Yup.ref("Password")],
                      t("Validation.PasswordNoMatched").toString()
                    ),
                })}
              >
                {({ handleSubmit }) => (
                  <Row className="mt-4">
                    {error && (
                      <Col md={12}>
                        <Alert color="danger">{error}</Alert>
                      </Col>
                    )}
                    {msg && (
                      <Col md={12}>
                        <Alert color="success">{msg}</Alert>
                      </Col>
                    )}
                    <GetInput
                      inputprop={{
                        field: "Password",
                        label: t("Authentication.Password").toString(),
                        type: "password",
                      }}
                    />
                    <GetInput
                      inputprop={{
                        field: "ConfirmPassword",
                        label: t("Authentication.ConfirmPassword").toString(),
                        type: "password",
                      }}
                    />
                    <Col md={12}>
                      <Button
                        className="w-100"
                        color="success"
                        type="submit"
                        style={{ fontSize: 12 }}
                        onClick={() => handleSubmit()}
                      >
                        {t("ResetPassword.Button")}
                      </Button>
                    </Col>
                  </Row>
                )}
              </Formik>
      </Layout>
    </React.Fragment>
  );
};

export default withRouter(ResetPassword);
ResetPassword.propTypes = {
  history: PropTypes.object,
};
